import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { RegistroService } from 'src/app/registro.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class NovedadIndService {
    constructor(
        private http: HttpClient,
        private registroService: RegistroService
    ) {}

    apiUrl = environment.apiSiriUrl;
    async getNovedadDate(year: string, semester: string) {
        const url = `${this.apiUrl}novedad/empresa-actual/${this.registroService.empresaSelected}/${year}/${semester}`;
        try {
            const response = await this.http.get<any[]>(url).toPromise();
            return response;
        } catch (error) {
            throw error;
        }
    }
}
